import React, { useState } from "react";

import { BaseControlProps } from "../../models/BaseControlProps";
import { UserAPIService } from "../../services/UserAPIService";
import { useAuth } from "../../services/AuthContext";
import { useMessage } from "../../components/Common/MessageContext/MessageContext";
import { Box, Button, CircularProgress, Divider, FormControl, FormControlLabel, FormLabel, Radio, RadioGroup, Switch, ToggleButton, ToggleButtonGroup, Typography } from "@mui/material";
import ConfirmPrompt from "../../components/Common/ConfirmPrompt/ConfirmPrompt";


const PaperPayslip = (Props: BaseControlProps) => {
    const [loading, setLoading] = useState(false);
    const userApiService = new UserAPIService();
    const authContext = useAuth();
    const { showMessage } = useMessage();
    const [payslipType, setPayslipType] = useState<string | null>(localStorage.getItem('sendPaperPaySlip'));
    const [confirmVisible, setConfirmVisible] = useState(false);
    const [confirmTitle, setConfirmTitle] = useState('');
    const [confirmMessage, setConfirmMessage] = useState('');
    const [confirmLoading, setConfirmLoading] = useState(false);
        

    const sendPaperPayslip = async () => {
        setLoading(true);
        const payslipChangeRequest = {
            paperPayslip: payslipType === 'true' ? true : false
        };
        userApiService.paperPayslipChange(payslipChangeRequest, authContext.token).then((response) => {
            if (response.error) {
                showMessage(response.error, 'error');
            }
            else {
                if(response.response?.requestSent){
                    showMessage("Paper payslip type changed successfully!", "success");
                    localStorage.setItem('sendPaperPaySlip', payslipType === 'true' ? 'true' : 'false');
                    setPayslipType(payslipType === 'true' ? 'true' : 'false')
                }
                else{
                    showMessage("Sorry, we couldn’t change the paper payslip type, please contact Mercer", 'error');
                }
            }
            setLoading(false);
            setConfirmLoading(false);
            setConfirmVisible(false);
        })
    }

    const handleConfirmCancel = () => {
        setConfirmVisible(false);
    }

    const handleConfirmConfirmed = async () => {
        setConfirmLoading(true);

        await sendPaperPayslip();
    }

    const renderConfirmPrompt = () => {
        return (
            <ConfirmPrompt 
                open={confirmVisible}
                title={confirmTitle}
                message={confirmMessage}
                onConfirm={handleConfirmConfirmed}
                onCancel={handleConfirmCancel}
                isLoading={confirmLoading}
            />
        );
    }

    return (
        <>
            <Box sx={{ width: '100%', pb: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography component="h2" variant="h5" gutterBottom>
                        Paper Payslip
                    </Typography>
                </Box>
                <Divider />
            </Box>
            <Box
                 sx={{ 
                    maxWidth: 600, // Maximum width of the form
                    margin: '20 auto', // Center the form horizontally
                    padding: 2, // Padding around the form
                    border: '1px solid #ddd', // Optional border for better visibility
                    borderRadius: 1 // Optional rounded corners
                }}
            >
                <form onSubmit={() => {}}>
                    <FormControl>
                        <FormLabel id="paper-slip-label" htmlFor="paper-slip-label">Send Paper Payslip : </FormLabel>
                        <RadioGroup
                            row
                            aria-labelledby="paper-slip-label"
                            id="paper-slip-button-group"
                            name="paper-slip-button-group"
                            value={payslipType}
                            onChange={(e, newValue) => newValue && setPayslipType(newValue) }
                        >
                            <FormControlLabel value="true" control={<Radio inputProps={{ 'aria-label': 'Yes, send paper payslip' }} />} label="Yes" />
                            <FormControlLabel value="false" control={<Radio inputProps={{ 'aria-label': 'No, do not send paper payslip' }} />} label="No" />
                        </RadioGroup>
                    </FormControl>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Box sx={{ marginLeft: 'auto' }}>
                            <Button 
                                variant="contained" 
                                fullWidth
                                disabled={loading} 
                                onClick={(e) => {
                                    setConfirmTitle('Send Paper Payslip');
                                    const msg = (payslipType === "true") ? "Are you sure you want to request to send paper payslip ?" :
                                        "Are you sure you want to request to stop sending paper payslip?";
                                    setConfirmMessage(msg);
                                    setConfirmVisible(true)
                                }}
                                startIcon={loading ? <CircularProgress size={20} color="inherit" /> : null}
                                sx={{
                                    '&.Mui-disabled': {
                                        color: (theme) => theme.palette.primary.contrastText,
                                    }
                                }}
                            >
                                {loading ? 'Loading...' : 'Request'}
                            </Button>
                        </Box>
                    </Box>
                </form>
            </Box>

            {renderConfirmPrompt()}
        </>
    )
}

export default PaperPayslip;